// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"ToolbarWidget_toolbar__VmPGW"};